<template>
  <div class>
    <Header />
    <div class="content-web container mt-5">
      <div class="row">
        <div class="banner-left col-sm-12 col-md-4 col-lg-4">
          <div>
            <h2>Make your own wave</h2>
            <div class="sku_banner_search mb-2">
              <div class="input-group">
                <span class="input-group-btn">
                  <button
                    id="home_search_engine"
                    class="btn btn-default"
                    type="button"
                    v-on:click="searchIP()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </span>
                <input
                  autocomplete="off"
                  id="home_search_engine_input"
                  type="text"
                  class="form-control"
                  placeholder="What're you looking for?"
                  @keyup.enter="searchIP()"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="banner-right col-sm-12 col-md-8 col-lg-8"
          v-if="banners!=undefined && banners.length > 0"
        >
          <VueSlickCarousel v-bind="settingBanner">
            <div v-for="item in banners" v-bind:key="item.id" class="banner-item">
              <a :href="item.url" target="_blank">
                <img v-bind:src="apiUrl + '/image/' + item.imageId" class="img-fit" />
              </a>
            </div>
          </VueSlickCarousel>
        </div>
      </div>

      <div class="container mb-5 mt-5" v-if="listNewSubmit && listNewSubmit.length">
        <div class="new-topic row">
          <div class="list-title col-12">Sáng kiến mới</div>
          <div v-if="loadingNewTopic" class="text-center" style="height: 425px; width: 100%;">
            <div class="spinner-border text-dark" role="status">
              <span class="sr-only">Đang tải...</span>
            </div>
          </div>

          <ListNewTopic :data="listNewSubmit" :columnNumber="column.newSubmit"></ListNewTopic>

          <div class="col-12 text-right">
            <a
              class="btn btn-primary btn-view-more"
              @click="redirect(`${formUrl}/sangkien`)"
            >Xem thêm</a>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import ListCarousel from "@/components/layout/ListCarousel.vue";
import ListGrid from "@/components/layout/ListGrid.vue";
import * as CONFIG from "@/config/index.js";
import axios from "axios";
import ideaCommon from "../../common/idea";

export default {
  name: "HomePage",
  components: {
    Header,
    Footer,
    VueSlickCarousel,
    ListNewTopic: ListGrid
  },
  data() {
    return {
      column: {
        iKhien: 5,
        newSubmit: 3
      },
      apiUrl: CONFIG.API_URL,
      formUrl: `${CONFIG.CLIENT_URL}/#/browse-ip`,
      listiKhien: [],
      listNewSubmit: [],
      settingBanner: {
        dotsClass: "slick-dots custom-dot-class",
        arrows: true,
        infinite: true,
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 10000,
        focusOnSelect: true,
        swipe: false
      },
      banners: [],
      loadingNewTopic: false,
      loadingStandardizedSolution: false,
      loadingSoftwareComponent: false,
      loadingCaseTools: false
    };
  },
  methods: {
    getColumnbyWidthScreen() {
      if (window.innerWidth < 480) {
        this.column.iKhien = 1;
        this.column.newSubmit = 1;
      } else if (window.innerWidth >= 480 && window.innerWidth < 768) {
        this.column.iKhien = 2;
        this.column.newSubmit = 2;
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        this.column.iKhien = 3;
        this.column.newSubmit = 3;
      } else {
        this.column.iKhien = 5;
        this.column.newSubmit = 4;
      }
    },
    redirect: function(href) {
      window.location.href = href;
    },
    getAPIBySpace() {
      this.getBanners();
      this.getNewSubmit();
      // this.getiKhien();
    },
    async getBanners() {
      let response;
      try {
        response = await axios.get(
          `${CONFIG.API_URL}/manageBanner/home-banner`
        );
      } catch (error) {
        return;
      }
      this.banners = response.data.data;
    },
    async getNewSubmit() {
      const form = {
        title: "",
        companyCode: "",
        type: ""
      };
      const result = await ideaCommon.searchIdea(form, 1, 8);
      this.listNewSubmit = result.items;
    },
    // async getiKhien() {
    //   this.listiKhien = await ideaCommon.getLatest("", 1, 5);
    // },
    searchIP() {
      const browseIpSearchUrl = `${CONFIG.CLIENT_URL}/#/browse-ip/sangkien`;
      let text_search = $("#home_search_engine_input").val();
      localStorage.setItem("home_search_engine_input", text_search);
      window.location.href = browseIpSearchUrl;
    }
  },
  async mounted() {
    this.getColumnbyWidthScreen();
    this.getAPIBySpace();
  }
};
</script>

<style scoped>
.list-recommend {
  margin: 0 -10px;
}

.recommend-list {
  margin: auto;
}

.list-title {
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.44;
  letter-spacing: 0.13px;
  text-align: left;
  color: #1e242f;
  text-transform: uppercase;
}

.recommend-list .list-title {
  color: #fff;
}
.img-fit {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.popular-tag .list-tags {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.banner-left {
  text-align: left;
  display: flex;
  flex-flow: column;
  justify-content: center;
  /* flex-direction: column; */
}

.banner-left > div {
  /* margin-top: auto; */
}

.banner-left h2 {
  font-size: 36px;
  font-style: normal;
  text-align: left;
  color: #1e242f;
  margin: 0 0 7px 0;
  font-weight: 100;
}

.banner-left p {
  font-size: 16px;
  font-style: normal;
  text-align: left;
  color: #1e242f;
  margin: 0;
}

#home_search_engine_input {
  width: 350px;
}

.sku_banner_search {
  margin-top: 24px;
}

.sku_banner_search button,
.sku_banner_search input {
  height: 42px;
  border: none;
}

.sku_banner_search button,
.sku_banner_search button:hover,
.sku_banner_search button:focus {
  width: 42px;
  border-radius: 21px !important;
  box-shadow: 0 16px 24px 0 rgba(224, 115, 83, 0.18);
  background-color: #ed8652;
  color: #fff;
  z-index: 1 !important;
  border: none !important;
}

.sku_banner_search button:hover,
.sku_banner_search button:focus {
  background-color: #ed8652a8;
}

.sku_banner_search .input-group-btn {
  position: absolute;
  z-index: 4;
}

.sku_banner_search input,
.sku_banner_search input:focus {
  border-radius: 21px !important;
  box-shadow: 0 16px 24px 0 rgba(224, 115, 83, 0.16);
  background-image: linear-gradient(to bottom, #f7f7f7, #ffffff);
  padding-left: 55px;
  font-size: 16px;
  color: #1e242f;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/HomePage.vue